import httpClient from '@/config';

const token = localStorage.getItem('token');
const headers = {
  headers: {
    Authorization: `Bearer ${token}`,
  },
};

export const getTractors = (take = 10, skip = 0, search = '') => new Promise((resolve, reject) => {
  headers.headers.take = take;
  headers.headers.skip = skip;
  headers.headers.search = search;
  httpClient.get(
    '/tractor',
    headers,
  )
    .then((response) => {
      const { data } = response;
      resolve(data);
    })
    .catch((error) => reject(error));
});

export const createTractor = (tractor) => new Promise((resolve, reject) => {
  httpClient.post(
    '/tractor',
    tractor,
    headers,
  )
    .then((response) => {
      console.log('response', response);
      resolve(response);
    })
    .catch((error) => reject(error));
});

export const getOneTractor = (id) => new Promise((resolve, reject) => {
  httpClient.get(
    `/tractor/${id}`,
    headers,
  )
    .then((response) => {
      const { data } = response;
      console.log('response', response);
      resolve(data);
    })
    .catch((error) => reject(error));
});

export const updateTractor = (id, tractor) => new Promise((resolve, reject) => {
  httpClient.put(
    `/tractor/${id}`,
    tractor,
    headers,
  )
    .then((response) => {
      const { data } = response;
      console.log('response', response);
      resolve(data);
    })
    .catch((error) => reject(error));
});

export const deleteTractor = (id, tractor) => new Promise((resolve, reject) => {
  httpClient.put(
    `/tractor/delete/${id}`,
    tractor,
    headers,
  )
    .then((response) => {
      const { data } = response;
      console.log('response', response);
      resolve(data);
    })
    .catch((error) => reject(error));
});
